import { openedSessionTabAtom, openedSessionTabEnum } from '@/atoms/sideNavAtoms';
import { IS_CONSOLIDATED_SESSIONS_LIST_ENABLED } from '@/components/constants/flags';
import { SessionReviewComboBox } from '@/components/layout/Navigation/sessions/header/review-combobox';
import { useShowSessionReview } from '@/hooks/useShowSessionReview';
import { useIsMobile } from '@/hooks/useWindowDimensions';
import { useAtomValue } from 'jotai';
import { memo } from 'react';
import SessionBarMobileButton from './new-session-mobile-button';
import MobileSessionBarPanelCloseButton from './panel-close-button';
import SessionBarScheduleTabHeaderButtons from './schedule-tab-header-buttons';
import SessionBarSearchBar from './search-bar';
import SessionBarStatusText from './status-text';
import SessionBarTitle from './title';
import { SessionsToolbar } from './toolbar';

function SessionsHeader() {
  const showSessionReview = useShowSessionReview();
  const openedSessionTab = useAtomValue(openedSessionTabAtom);
  const isConsolidatedSessionsEnabled = IS_CONSOLIDATED_SESSIONS_LIST_ENABLED();

  const isMobile = useIsMobile();

  return (
    <>
      <div className="flex h-6 items-center justify-between">
        {isMobile && <SessionBarTitle />}

        {!isConsolidatedSessionsEnabled && showSessionReview && <SessionReviewComboBox />}

        {openedSessionTab === openedSessionTabEnum.PAST && <SessionsToolbar />}

        <SessionBarScheduleTabHeaderButtons />

        <MobileSessionBarPanelCloseButton />
      </div>

      <SessionBarStatusText />

      <SessionBarSearchBar />

      {/* new session button on mobile */}
      <SessionBarMobileButton />
    </>
  );
}

export default memo(SessionsHeader);
